/**
 * Chat Service for Trade Advisor AI Agent Chatbot
 * Handles communication with Cloud Functions
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import {
  ChatResponse,
  TransactionConfirmation,
  ExecuteTransactionResult
} from '../types/chat';

export class ChatService {
  /**
   * Send a message to the chat assistant
   */
  static async sendMessage(
    message: string,
    history: { role: string; content: string }[]
  ): Promise<ChatResponse> {
    const chatWithAssistant = httpsCallable<
      { message: string; conversationHistory: { role: string; content: string }[] },
      ChatResponse
    >(functions, 'chatWithAssistant');

    const result = await chatWithAssistant({
      message,
      conversationHistory: history
    });

    return result.data;
  }

  /**
   * Execute a confirmed transaction
   */
  static async executeTransaction(
    confirmation: TransactionConfirmation
  ): Promise<ExecuteTransactionResult> {
    const executeTransaction = httpsCallable<
      TransactionConfirmation,
      ExecuteTransactionResult
    >(functions, 'executeTransaction');

    const result = await executeTransaction(confirmation);
    return result.data;
  }
}
